import React from 'react'
import { QuoteBounce } from '@/components/animations/QuoteBounce'

interface EmptyStateProps {
  projectId: string
  projectName: string
}

export const EmptyState = ({ projectId, projectName }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 border rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-8 h-[80vh] relative overflow-hidden">
      {/* Quote bouncing animation */}
      <QuoteBounce quoteCount={6} />

      {/* Quote icon */}
      <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-6 relative z-10">
        <svg className="w-8 h-8 text-[#FF4A8E]" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5015 11H6.50146C6.23625 11 5.98189 10.8946 5.79436 10.7071C5.60682 10.5196 5.50146 10.2652 5.50146 10V7C5.50146 6.73478 5.60682 6.48043 5.79436 6.29289C5.98189 6.10536 6.23625 6 6.50146 6H9.50146C9.76668 6 10.021 6.10536 10.2086 6.29289C10.3961 6.48043 10.5015 6.73478 10.5015 7V13C10.5015 15.667 9.16846 17.333 6.50146 18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5015 11H15.5015C15.2362 11 14.9819 10.8946 14.7944 10.7071C14.6068 10.5196 14.5015 10.2652 14.5015 10V7C14.5015 6.73478 14.6068 6.48043 14.7944 6.29289C14.9819 6.10536 15.2362 6 15.5015 6H18.5015C18.7667 6 19.021 6.10536 19.2086 6.29289C19.3961 6.48043 19.5015 6.73478 19.5015 7V13C19.5015 15.667 18.1685 17.333 15.5015 18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2 relative z-10">
        No quotes collected yet
      </h3>
      <p className="text-gray-500 dark:text-gray-400 text-center max-w-md mb-6 relative z-10">
        Quotes will be automatically collected from your meetings and conversations. They help track key insights and
        feedback from your customers.
      </p>
    </div>
  )
}
